export default "__VITE_ASSET__275cd9dc__"